function updateVariantPrice(t, a) {
    var e = t.getAttribute("data-price"),
        r = t.getAttribute("data-compare-price"),
        n = t.getAttribute("data-variant-id");

    e = e.replace(/[^0-9.]/g, "");
    r = r ? r.replace(/[^0-9.]/g, "") : "";

    e = Number(e);
    r = Number(r);

    console.log("new price : ", e);
    console.log("comparePrice : ", r);

    var c = document.getElementById("price-" + a),
        i = Math.floor(e).toLocaleString(),
        o = r ? Math.floor(r).toLocaleString() : "";

    if (r && r > e) {
        c.innerHTML = `
            <span class="compare-price" style="text-decoration: line-through; color: red;">
                Rs. ${o}
            </span>
            <span class="sale-price"> Rs. ${i}</span>
        `;
    } else {
        c.innerHTML = `<span class="sale-price">Rs. ${i}</span>`;
    }

    t.closest(".variant-tabs")
        .querySelectorAll(".variant-tab")
        .forEach(tab => {
            tab.classList.remove("active-variant");
        });

    t.classList.add("active-variant");
    updateAddToCartButton(n, a);
}

function updateAddToCartButton(variantId, productId) {
    document.getElementById("cart-btn-" + productId).innerHTML = `
        <button class="add-to-cart-btn" onclick="addToCart(${variantId})">
            Add to Cart
        </button>
    `;
}

function addToCart(variantId) {
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
        console.log("Added to cart:", data);
        openCartDrawer();
    })
    .catch(error => {
        console.error("Error adding to cart:", error);
    });
}

function openCartDrawer() {
    let cartDrawerTrigger = document.querySelector(".js-drawer-open-cart");
    if (cartDrawerTrigger) {
        cartDrawerTrigger.click();
        setTimeout(() => {
            if (cartDrawerTrigger.offsetParent !== null) cartDrawerTrigger.click();
        }, 300);
        setTimeout(() => {
            if (cartDrawerTrigger.offsetParent !== null) cartDrawerTrigger.click();
        }, 600);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".variant-tabs").forEach(t => {
        var a = t.querySelector(".variant-tab");
        if (a) {
            console.log("Triggering first variant click", a);
            setTimeout(() => {
                a.click();
                var productId = a.closest(".variant-tabs").getAttribute("data-product-id");
                updateAddToCartButton(a.getAttribute("data-variant-id"), productId);
            }, 500);
        }
    });
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.href === "https://scentsnsecrets.com/collections/gift-box") {
    setTimeout(function () {
      const cartButtons = document.querySelectorAll('.add-to-cart-btn');
      if (cartButtons.length > 0) {
        console.log("Hiding add-to-cart buttons");
        cartButtons.forEach(function (btn) {
          btn.style.display = 'none';
        });
      } else {
        console.warn("No elements with class 'add-to-cart-btn' found.");
      }
    }, 1000); // 1 second delay
  }
  else{
    console.log("sab set chal raha haii")
  }
});
